import React, { useEffect, useState } from 'react'
import { LooksOne } from '@mui/icons-material'
import { Box, Stack, Typography } from '@mui/material'
import NormalText from 'common/Typography/NormalText'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'
import { TransformedFaberUserData } from 'types/api/faber/globalCustomers.type'

interface Props {
  dataRemaining: number
  customerRow: TransformedFaberUserData
  otpackDataRemaining: number
}
export default function DataRemainingCardV2({
  dataRemaining,
  customerRow,
  otpackDataRemaining
}: Props) {
  const [finalDataLeft, setFinalDataLeft] = useState('')

  useEffect(() => {
    setFinalDataLeft((Math.round((dataRemaining / 1024) * 10) / 10).toFixed(1))
  }, [dataRemaining])

  return (
    <>
      <Box
        sx={{
          width: '80px',
          height: '80px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background:
            otpackDataRemaining !== 0 || finalDataLeft !== '0'
              ? circlesOrbitColorPalette.success.main
              : circlesOrbitColorPalette.error,
          position: 'absolute',
          ml: '9rem',
          borderRadius: '50%',
          mt: '-70px'
        }}
      >
        <LooksOne sx={{ fontSize: '40px', color: 'white' }} />
      </Box>

      <NormalText
        isBold
        textAlign={'left'}
        sx={{
          fontSize: '24px',
          fontWeight: '700px',
          m: 0
        }}
        text={'Data left'}
      />
      <TextColorFontBody
        sx={{
          fontSize: '14px',
          lineHeight: 1,
          color: '#7B8794',
          textAlign: 'left',
          mt: '10px'
        }}
      >
        The <strong>total</strong> amount of data (in GB) that the customer has
        left
      </TextColorFontBody>
      <Stack
        flexDirection={'row'}
        sx={{ mt: '37px', justifyContent: 'space-between' }}
      >
        <Stack>
          <Typography
            sx={{
              fontWeight: '400',
              color: '#7B8794',
              justifyContent: 'space-between'
            }}
            textAlign='left'
          >
            Status
          </Typography>

          <NormalText
            component='div'
            sx={{
              fontWeight: '600',
              fontSize: '33px',
              pt: '15px'
            }}
          >
            {customerRow.subscription ? finalDataLeft : otpackDataRemaining.toFixed(2)} GB
          </NormalText>
        </Stack>
      </Stack>
    </>
  )
}
